import posthog from "posthog-js";
import { axiosBasic, getUserInfo } from "../../../api/axios";
import { config } from "../../../api/endPoints";
import { actionTypes } from "./teamActionTypes";
import { UPDATE_PAGING } from "../../common/pagination/paginationActionTypes";
import { Common } from "../../../utils";

const { Team } = config.REST_API;

const getAll = (items) => ({ type: actionTypes.TM_SHOW_LIST, payload: items });
const softDelete = (item) => ({ type: actionTypes.TM_DELETE_SOFT, payload: item });

export const TeamListing = (options, currentPage) => {
  const take = options.take ?? options.limit ?? 20;
  const newUrl =
    Team.Get +
    options.start +
    "/" +
    options.page +
    "/" +
    take;
  return (dispatch) => {
    const userId = getUserInfo()?.selfUserId ?? null;
    const userInput = { start: options.start, page: options.page, take, currentPage };
    dispatch({ type: actionTypes.TM_LOADING_START });
    axiosBasic
      .get(newUrl)
      .then((response) => {
        const baseModel = response.data;
        const success = baseModel.success;
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("TeamListing", {
            type: success ? "info" : "exception",
            userId,
            success,
            userInput,
            reason: success ? undefined : baseModel.message,
          });
        }
        if (success) {
          dispatch({
            type: UPDATE_PAGING,
            payload: { data: { total: baseModel.total, currentPage } },
          });
          dispatch(getAll(baseModel.data));
        } else {
          Common.showErrorMessage(baseModel.message);
        }
      })
      .catch((error) => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("TeamListing", {
            type: "exception",
            userId,
            success: false,
            userInput,
            reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
          });
        }
        Common.showErrorMessage("Something went wrong");
        console.log(error);
      });
  };
};

export const saveTeam = (model) => {
  const obj = {
    Name: model.name.trim(),
    Notes: (model.notes || "").trim(),
  };
  return (dispatch) => {
    const userId = getUserInfo()?.selfUserId ?? null;
    const userInput = { hasName: !!(model?.name?.trim()), hasNotes: !!(model?.notes?.trim()) };
    dispatch({ type: actionTypes.TM_LOADING_START });
    return axiosBasic
      .post(Team.Create, obj)
      .then((response) => {
        const res = response.data;
        const success = res.success;
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("saveTeam", {
            type: success ? "info" : "exception",
            userId,
            success,
            userInput,
            reason: success ? undefined : res.message,
          });
        }
        if (success) {
          dispatch({ type: actionTypes.TM_ADD_SUCCESS, payload: res.data });
        }
        dispatch({ type: actionTypes.TM_LOADING_STOP });
        return res;
      })
      .catch((error) => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("saveTeam", {
            type: "exception",
            userId,
            success: false,
            userInput,
            reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
          });
        }
        dispatch({ type: actionTypes.TM_LOADING_STOP });
        return error;
      });
  };
};

const toPatchBody = (item) => ({
  Id: item.id ?? item.Id,
  Name: item.name ?? item.Name,
  Notes: item.notes ?? item.Notes ?? "",
  IsActive: item.isActive !== undefined ? item.isActive : item.IsActive !== false,
});

export const patchTeam = (item) => {
  const obj = toPatchBody(item);
  return (dispatch) => {
    const userId = getUserInfo()?.selfUserId ?? null;
    const userInput = { id: obj.Id, hasName: !!obj.Name, hasNotes: !!obj.Notes };
    dispatch({ type: actionTypes.TM_LOADING_START });
    return axiosBasic
      .patch(Team.Patch, obj)
      .then((response) => {
        const res = response.data;
        const success = res.success;
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("patchTeam", {
            type: success ? "info" : "exception",
            userId,
            success,
            userInput,
            reason: success ? undefined : res.message,
          });
        }
        if (success) {
          dispatch({ type: actionTypes.TM_UPDATE_SUCCESS, payload: res.data });
        }
        dispatch({ type: actionTypes.TM_LOADING_STOP });
        return res;
      })
      .catch((error) => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("patchTeam", {
            type: "exception",
            userId,
            success: false,
            userInput,
            reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
          });
        }
        dispatch({ type: actionTypes.TM_LOADING_STOP });
        return error;
      });
  };
};

export const deleteTeam = (item) => {
  const id = item.id ?? item.Id;
  return (dispatch) => {
    const userId = getUserInfo()?.selfUserId ?? null;
    const userInput = { id };
    dispatch({ type: actionTypes.TM_LOADING_START });
    return axiosBasic
      .delete(`${Team.Delete}${encodeURIComponent(id ?? "")}`, {
        transformRequest: [
          (data, headers) => {
            delete headers["Content-Type"];
            return data;
          },
        ],
      })
      .then((response) => {
        dispatch({ type: actionTypes.TM_LOADING_STOP });
        const baseModel = response.data;
        const success = baseModel.success;
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("deleteTeam", {
            type: success ? "info" : "exception",
            userId,
            success,
            userInput,
            reason: success ? undefined : baseModel.message,
          });
        }
        if (success) {
          const list = baseModel.data ?? baseModel.Data;
          if (Array.isArray(list)) {
            dispatch(getAll(list));
          } else {
            dispatch(softDelete(item));
          }
        }
        const msg =
          typeof baseModel.message === "string"
            ? baseModel.message
            : baseModel.message?.message ?? baseModel.message?.Message;
        return { success: !!success, message: msg };
      })
      .catch((error) => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("deleteTeam", {
            type: "exception",
            userId,
            success: false,
            userInput,
            reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
          });
        }
        dispatch({ type: actionTypes.TM_LOADING_STOP });
        throw error;
      });
  };
};

/**
 * GET Team/UserTeams/{teamId} — flat memberships (`ProjectUserTeamItem`) for roster review in project form.
 * Returns `{ rows, error }` (no Redux).
 */
export async function fetchTeamUserTeams(teamId) {
  const sid = String(teamId ?? "").trim();
  if (!sid) {
    return { rows: [], error: "Missing team id" };
  }
  try {
    const res = await axiosBasic.get(`${Team.UserTeams}${encodeURIComponent(sid)}`);
    const body = res.data;
    const ok = body?.success === true || body?.Success === true;
    if (!ok) {
      return {
        rows: [],
        error: body?.message ?? body?.Message ?? "Request failed",
      };
    }
    const raw = body.data ?? body.Data;
    const rows = Array.isArray(raw) ? raw : [];
    return { rows, error: null };
  } catch (error) {
    return {
      rows: [],
      error: error?.response?.data?.message ?? error?.message ?? "Request failed",
    };
  }
}
